import { Button, Spinner, Tooltip } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import Countdown, { CountdownRendererFn } from "react-countdown";
import { useTranslation } from "react-i18next";

type CancelButtonProps = {
  loading?: boolean;
  onClick?: () => void;
  countdown?: number;
  activateCountdown?: boolean;
};

export function CancelButton({ loading, onClick, countdown, activateCountdown }: CancelButtonProps) {
  const { t } = useTranslation();
  const [countdownDate, setCountdownDate] = useState<Date | undefined>(undefined);
  const [isEnabled, setIsEnabled] = useState(countdown === undefined);

  useEffect(() => {
    if (activateCountdown && countdown !== undefined) {
      setCountdownDate(new Date(Date.now() + countdown * 1000));
    } else {
      setCountdownDate(undefined);
    }
  }, [activateCountdown, countdown]);

  const countdownRenderer: CountdownRendererFn = ({ seconds }) => {
    return (
      <>
        <Spinner />
        <span className="tabular-nums">{seconds.toString().padStart(2, "0")}s</span>
      </>
    );
  };

  return (
    <>
      <Tooltip content={t("cancelCheckout")}>
        <Button
          color="red"
          size="3"
          variant="soft"
          className="!min-w-[160px]"
          disabled={!isEnabled}
          loading={loading}
          onClick={onClick}
        >
          {activateCountdown && countdown !== undefined && !!countdownDate ? (
            <Countdown
              renderer={countdownRenderer}
              onComplete={() => {
                setIsEnabled(true);
                setCountdownDate(undefined);
              }}
              autoStart
              date={countdownDate}
            />
          ) : (
            t("cancelCheckout")
          )}
        </Button>
      </Tooltip>
    </>
  );
}
